import clone from 'lodash/clone';

import { camelCase } from 'lib/utils/objectSerializer';
import formatUser from './format';

const initialState = {
  loading: false,
  users: [],
  usersById: {},
  orgId: '',
  branchId: '',
  userCount: 0,
  employee: null,
};

export default function userReducer(state = initialState, action = {}) {
  switch (action.type) {
    case 'DELETE_USER_REQUEST': {
      if (action.extra && action.extra.userId) {
        const userId = action.extra.userId;
        const usersById = clone(state.usersById);
        if (userId in usersById) {
          delete usersById[userId];
        }
        const users = state.users.filter((user) => user.id !== userId);
        return {
          ...state,
          users,
          usersById,
        };
      }

      return state;
    }

    case 'GET_MORE_USERS_REQUEST':
    case 'GET_USERS_REQUEST': {
      return {
        ...state,
        loading: true,
      };
    }

    case 'GET_USERS_SUCCESS': {
      const { result, total_count: userCount } = action.payload;
      const usersById = result.reduce(
        (accum, user) => ({ ...accum, [user.id]: user }),
        {},
      );

      return {
        ...state,
        loading: false,
        users: result,
        usersById,
        userCount,
      };
    }

    case 'GET_MORE_USERS_SUCCESS': {
      const { result } = action.payload;
      const users = [...state.users, ...result];
      const usersById = users.reduce(
        (accum, user) => ({ ...accum, [user.id]: user }),
        {},
      );

      return {
        ...state,
        loading: false,
        users,
        usersById,
      };
    }

    case 'GET_USER_SUCCESS': {
      return {
        ...state,
        loading: false,
        employee: formatUser(camelCase(action.payload)),
      };
    }

    case 'RESET_EMPLOYEE_STATE': {
      return {
        ...state,
        employee: null,
      };
    }

    case 'LOGOUT_SUCCESS': {
      return initialState;
    }

    default:
      return state;
  }
}

export { initialState };
